export default "__VITE_ASSET__3K4BENX8__"